import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DashboardService } from '../../../../../services/dashboard.service';
import { SharedService } from '../../../../../services/shared.service';

@Component({
  selector: 'app-text-form',
  templateUrl: './text-form.component.html',
  styleUrls: ['./text-form.component.css']
})
export class TextFormComponent implements OnInit {


  @ViewChild('quillFile') quillFileRef: ElementRef;

  @Input("form") form: FormGroup;

  quillFile: any;
  meQuillRef: any;
  editorModules = {
    toolbar: {
      container: [

        [{ size: [] }],
        [{ color: [] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'header': '1' }, { 'header': '2' }, 'blockquote', 'code-block'],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
        ['direction', { 'align': [] }],
        ['link', 'image'],
        ['clean'],
        ['html']
      ],
      handlers: {
        image: (image) => {
          this.customImageUpload(image);
        },
        html: () => {
          this.customHtml();
        }
      }
    },
  };

  constructor(private _dashboardService: DashboardService, private _sharedService: SharedService) { }
  ngOnInit() {
  }


  getMeEditorInstance(editorInstance: any) {
    this.meQuillRef = editorInstance;
    const htmlButton = document.getElementsByClassName("ql-html");
    htmlButton[0].innerHTML += '<i class="fa fa-pencil"></i>';

  }

  customHtml() {
    const selection = window.getSelection();
    const text = window.getSelection().toString();
    selection.deleteFromDocument();
    let range = this.meQuillRef.getSelection();
    this.meQuillRef.clipboard.dangerouslyPasteHTML(range.index, text);
  }

  customImageUpload(image: any) {
    /* Here we trigger a click action on the file input field, this will open a file chooser on a client computer */
    this.quillFileRef.nativeElement.click();
  }

  quillFileSelected(ev: any) {
    /* After the file is selected from the file chooser, we handle the upload process */
    this.quillFile = ev.target.files[0];
    this._dashboardService.uploadFile({ token: this._sharedService.getSlider().token, id: 5, file: this.quillFile }).subscribe(uploaded => {
      const basePath = this._dashboardService.getBasePath();
      const downloadPath = "bloccofile/Download/";
      const filename = `${basePath}${downloadPath}${uploaded.tokenProprietario}/${uploaded.token}`;
      let range: any;
      const img = '<img class="html-container-img" src="' + filename + '"></img>';
      range = this.meQuillRef.getSelection();
      this.meQuillRef.clipboard.dangerouslyPasteHTML(range.index, img);
    },
      err => { });
  }


}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/utils/item-type-manager/forms/text-form/text-form.component.ts